// Même URL que react-email-editor : le navigateur réutilise le fichier préchargé quand la librairie l'injecte.
// On ne l'injecte pas nous-mêmes : la librairie n'attend que le chargement du script qu'elle a ajouté.
const UNLAYER_ORIGIN = 'https://editor.unlayer.com';
const UNLAYER_SCRIPT_URL = `${UNLAYER_ORIGIN}/embed.js?2`;

let preloaded = false;

const addLink = (attributes: Record<string, string>) => {
  const link = document.createElement('link');
  Object.entries(attributes).forEach(([name, value]) => link.setAttribute(name, value));
  document.head.appendChild(link);
};

export const preloadUnlayer = () => {
  if (preloaded || typeof document === 'undefined') return;
  preloaded = true;
  addLink({ rel: 'preconnect', href: UNLAYER_ORIGIN, crossorigin: '' });
  addLink({ rel: 'preload', as: 'script', href: UNLAYER_SCRIPT_URL });
};
